import React, { useState, useEffect, useContext, useCallback } from "react";
import { getAllDocTypes, getAllSubTypes } from "../../services/dms/dms-admin";
import { downloadFile, filterFiles, getAllPublishedFiles, getUserFilesOnDbClick } from '../../services/dms/dms-user'
import { MenuContext } from "./DocumentMenuContext";
import { Container } from "../../styles/common.styles";
import { NoDataContainer } from '../../styles/common.styles';
import { getAllLanguages } from '../../services/user-services/user-level-services';
import Loader from "../common/Loader/Loader";
import './UserDocManagement.css'
import { filterDoctypeFiles, getAllDocuments } from "../../services/dms/dms-user";
import { toast } from "react-toastify";
import onClickViewDoc from "./ViewDocument";
import { DataTableComponent } from "../common/TableComponent/DataTableComponent";
import { useTranslation } from "react-i18next";
import { set } from "react-hook-form";
 
 
// let languageOptions = [];
 
const UserDocumentManagement = () => {
  const { t, i18n } = useTranslation();
  const [languageOptions, setLanguageOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [folders, setFolders] = useState([]);
  const [subFolders, setSubFolders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const { setDocMenuItems, setDocSubmenuItems, setHandleMenuItemClick, setHandleSubMenuItemClick, setHandleMenuItemDbClick, setHandleMenuAllItemClick } = useContext(MenuContext);
  const [searchVal, setSearchVal] = useState({ name: '', language: '' });
  const [docTypeId, setDoctypeId] = useState();
  const [subDocTypeId, setSubDoctypeId] = useState();
  const [allClicked, setAllClicked] = useState(false);
  const initialColumns = () => [
    { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true },
    { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
    { name: t("documentType"), field: "typeName", selector: (row) => row.typeName, sortable: true },
    { name: t("documentSubType"), field: "subTypeName", selector: (row) => row.subTypeName, sortable: true },
  ];
  const [columns, setColumns] = useState(initialColumns());

  useEffect(() => {
    fetchUserLanguages();
    // eslint-disable-next-line
    if (allClicked) {
      setColumns(initialColumns());
    } else if (docTypeId && subDocTypeId) {
      // Only show documentTitle and language columns for subdoctype view
      setColumns([
        { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true },
        { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
      ]);
    } else if (docTypeId) {
      // Show documentTitle, language, and documentSubType for doctype view
      setColumns([
        { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true },
        { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
        { name: t("documentSubType"), field: "subTypeName", selector: (row) => row.subTypeName, sortable: true },
      ]);
    }
  }, [i18n.language, docTypeId, subDocTypeId, allClicked]);

 useEffect(() => {
  if (allClicked) {
    handleAllMenuClick();
  } else {
    if (docTypeId) {
      getAllSubTypeDocs(docTypeId);
      handleMenuItemMainDocumentClick(docTypeId);
      if (subDocTypeId) {
        handleSubMenuItemClick(subDocTypeId, docTypeId);
    }
  }
}  
  // eslint-disable-next-line
}, [i18n.language, docTypeId]);
  const handleMenuItemClick = useCallback(async (itemId) => {
    setColumns([
      { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true },
      { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
      { name: t("documentSubType"), field: "subTypeName", selector: (row) => row.subTypeName, sortable: true },
    ]);
    setLoading(true);
    setAllClicked(false);
    setSearchVal({ name: '', language: '' });
    const subTypeDocs = await getAllSubTypes(itemId);

    if (subTypeDocs?.data) {
      setDocSubmenuItems(filterDataByLanguage(subTypeDocs?.data, i18n.language));
      setSubFolders(filterDataByLanguage(subTypeDocs?.data, i18n.language));
    } else {
      setDocSubmenuItems([]);
    }
    setLoading(false);
  }, []);
 
  const handleSubMenuItemClick = useCallback(async (subtypeId, typeId) => {
    setColumns([
      { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true },
      { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
    ]);
    setLoading(true);
    setDoctypeId(typeId);
    setSubDoctypeId(subtypeId);
    setAllClicked(false);
    setSearchVal({ name: '', language: '' });
    const files = await getAllPublishedFiles({
      typeId: typeId,
      subTypeId: subtypeId,
    });
    setTableData(fetchDataByLanguage(files?.data || [], i18n.language, typeId, subtypeId));
    setLoading(false);
  }, [t]);

  const fetchDataByLanguage = useCallback((data, lang, typeId, subtypeId) => {
    return data?.map(item => {
      let displayName = "";
      let documentTypeDisplay = "";
      let documentSubTypeDisplay = "";
      if (subtypeId) {
        // Only check for name in the selected language
        if (lang === "jp" && item.name_JP) {
          displayName = item.name_JP;
        } else if (lang === "ch" && item.name_CH) {
          displayName = item.name_CH;
        } else if (lang === "en" && item.name) {
          displayName = item.name;
        }
      } else {
        // Check for type and subtype names in the selected language
        if (lang === "jp" && item.name_JP && item.typeName_JP && item.subTypeName_JP) {
          displayName = item.name_JP;
          documentTypeDisplay = item.typeName_JP;
          documentSubTypeDisplay = item.subTypeName_JP;
        } else if (lang === "ch" && item.name_CH && item.typeName_CH && item.subTypeName_CH) {
          displayName = item.name_CH;
          documentTypeDisplay = item.typeName_CH;
          documentSubTypeDisplay = item.subTypeName_CH;
        } else if (lang === "en" && item.name && item.typeName && item.subTypeName) {
          displayName = item.name;
          documentTypeDisplay = item.typeName;
          documentSubTypeDisplay = item.subTypeName;
        }
      }

      return {
        ...item,
        name: displayName,
        typeName: documentTypeDisplay,
        subTypeName: documentSubTypeDisplay,
      };
    })?.filter(item => item.name && item.name.trim() !== "");
}, [i18n.language, subDocTypeId]);

  const handleMenuItemMainDocumentClick = useCallback(async (typeId) => {
    setColumns([
      { name: t("documentTitle"), field: "name", selector: (row) => row.name, sortable: true },
      { name: t("language"), field: "language", selector: (row) => row.language, sortable: true },
      { name: t("documentSubType"), field: "subTypeName", selector: (row) => row.subTypeName, sortable: true },
    ]);
    setLoading(true);
    setDoctypeId(typeId);
    setSubDoctypeId(null);
    setAllClicked(false);
    setSearchVal({ name: '', language: '' });
    const files = await getUserFilesOnDbClick(typeId);
    setTableData(fetchDataByLanguage(files?.data || [], i18n.language, typeId, null));
    setLoading(false);
  }, [t]);
 
  const handleAllMenuClick = useCallback(async (searchData, allDocs) => {
    setLoading(true);
    if (!allDocs) {
      setSearchVal({ name: '', language: '' });
      setAllClicked(true);
    }              
    const result = await getAllDocuments(searchData || searchVal);
    if (result?.data) {
      setTableData(fetchDataByLanguage(result.data, i18n.language, null, null));
    } else {
      setTableData([]);
    }
    setLoading(false); 
  }, []);
 
  useEffect(() => {
  const loadAll = async () => {
    setLoading(true);
    await fetchData();
    await fetchUserLanguages();
    await handleAllMenuClick('');
    setLoading(false);
  };
  loadAll();
  // eslint-disable-next-line
}, []);

const filterDataByLanguage = (data, lang) => {
  return data.filter(item => {
    if (lang === "jp") {
      return item.name_JP && item.name_JP.trim() !== "" && item.name_JP.trim().toLowerCase() !== "undefined";
    } else if (lang === "ch") {
      return item.name_CH && item.name_CH.trim() !== "" && item.name_CH.trim().toLowerCase() !== "undefined";
    } else if (lang === "en") {
      return item.name && item.name.trim() !== "" && item.name.trim().toLowerCase() !== "undefined";
    }
    return false;
  });
};
    
 
  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await getAllDocTypes();
      setFolders(filterDataByLanguage(result.data, i18n.language));
      setDocMenuItems(filterDataByLanguage(result.data, i18n.language));
    } catch (error) {
      console.error(t("errorFetchingData"), error);
    } finally {
      setLoading(false);
    }
  };

  const getAllSubTypeDocs = async (typeId) => {
    try {
      setLoading(true);
      const subTypeDocs = await getAllSubTypes(typeId);
      setSubFolders(filterDataByLanguage(subTypeDocs?.data, i18n.language));
  } catch (error) {
    console.error(t("errorFetchingData"), error);
  } finally {
      setLoading(false);
    }
  };

  const onViewDoc = async (row, rowIndex) => {
    onClickViewDoc(row);
  }
 
  const onCopyLink = async (row, rowIndex) => {
    let url = '';
    if (row.documentAccessibilityLevelName === 'Public') {
      url = await onClickViewDoc(row, null, 'copy');
    } else {
      url = window.location.origin + '/view-document/' + encodeURIComponent(row?.documentUrl) + '?accessibilityLevel=' + row?.documentAccessibilityLevelName;
    }
    navigator.clipboard.writeText(url)
      .then(() => {
        toast.success(t("linkCopiedToClipboard"));
      })
      .catch(err => {
        toast.error(t("failedToCopyLink"), err);
      });
  }
 
  const onDownloadDoc = async (row, rowIndex) => {
    const resp = await downloadFile(row);
    const documentUrl = row.documentUrl;
    const urlParts = documentUrl.split('/');
    const fileNameWithExtension = urlParts[urlParts.length - 1];
    const [name, extension] = fileNameWithExtension.split('.');
    const blob = new Blob([resp], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${row.name}.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
 
  const onInputChange = (e) => {
    const { name, value } = e.target;
    setSearchVal({ ...searchVal, [name]: value })
  }
 
  const handleFilter = async () => {
    if (allClicked) {
        handleAllMenuClick(searchVal, allClicked);
        return;
      }
    if (!docTypeId || !subDocTypeId){
      return;
    }
    setLoading(true);
    const resp = await filterFiles(searchVal, docTypeId, subDocTypeId);
    setTableData(resp.data);
    setLoading(false);
  }
 
  const handleDocFilter = async () => {
    if (allClicked) {
        handleAllMenuClick(searchVal, allClicked);
        return;
    }
    if (!docTypeId) return;
    setLoading(true);
    const resp = await filterDoctypeFiles(searchVal, docTypeId);
    setTableData(resp.data);
    setLoading(false);
  }
 
  useEffect(() => {
    setHandleMenuItemClick(() => handleMenuItemClick);
    setHandleSubMenuItemClick(() => handleSubMenuItemClick);
    setHandleMenuItemDbClick(() => handleMenuItemMainDocumentClick);
    setHandleMenuAllItemClick(() => handleAllMenuClick);
  }, [handleMenuItemClick, handleSubMenuItemClick, handleMenuItemMainDocumentClick]);
 
  const fetchUserLanguages = async () => {
    setLoading(true);
    const lang = await getAllLanguages();
    let Options = [];
    if (lang?.data) {
      Options = [
        { value: "", label: t("selectLanguage") },
        ...lang.data.map(({ languageCode, name }) => ({
          value: languageCode,
          label: name,
        })),
      ];
    }
    setLanguageOptions(Options); // <-- use state!
    setLoading(false);
  };
 
  return (
    <Container style={{ minHeight: "calc(99.1vh - 2.3rem)" }}>
      {loading && <Loader />}
      <div className="right-main-content">
        <div className="searchDiv">
        <input type="text" placeholder={t("documentTitle")} name="name" className="searchBox" onChange={onInputChange} value={searchVal.name} />
        <select className="select-dropdown" onChange={onInputChange} value={searchVal.language} name="language">
            {languageOptions.map((item, index) => {
              return <option key={index} value={item.value}>{item.label}</option>
            })}
          </select>
          <button className="searchBtn" onClick={columns.find(col => col.field === 'subTypeName') ? handleDocFilter : handleFilter}></button>
        </div>
        {tableData.length > 0 ? (
          <div className="glbOuterWrapper">
            <DataTableComponent
              columns={columns}
              data={tableData}
              onEditDetails={''}
              tableName="UserDocument"
              onDownloadDoc={onDownloadDoc}
              onViewDoc={onViewDoc}
              onCopyLink={onCopyLink}
            />
          </div>
        ) : (
          <NoDataContainer>
            <h1 style={{ textAlign: "center", margin: "0 auto" }}>
              {t("noDocumentsFound")}
            </h1>
          </NoDataContainer>
        )}
      </div>
    </Container>
  );
}
 
export default UserDocumentManagement;
